import { cn } from "@/lib/utils";

interface MarqueeProps {
  items: string[];
  className?: string;
  /** Seconds for one full loop. */
  speed?: number;
  reverse?: boolean;
}

/**
 * Slow editorial marquee. CSS-driven (GPU transform) so it stays smooth and
 * respects reduced-motion via the global CSS rule that pauses animations.
 */
export function Marquee({
  items,
  className,
  speed = 40,
  reverse = false,
}: MarqueeProps) {
  const loop = [...items, ...items];
  return (
    <div
      className={cn(
        "group relative flex w-full overflow-hidden",
        className,
      )}
    >
      <div
        className="flex shrink-0 items-center gap-12 pr-12 will-change-transform animate-marquee"
        style={{
          animationDuration: `${speed}s`,
          animationDirection: reverse ? "reverse" : "normal",
        }}
        aria-hidden={false}
      >
        {loop.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-12 text-2xl font-medium tracking-tight text-muted-foreground sm:text-3xl"
          >
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-accent/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
